import { Button, Divider, Step, StepContent, StepLabel, Stepper, } from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { contactListInitialValues, } from '../../commons/assets/InitialValues';
import { EditableTextField } from '../../commons/EditableTextField';
import { SubName } from '../../commons/style/MUI.Styles';
import { contactListValidationSchema } from '../../commons/validation/ContactListValidation';
import { ComplianceForm } from '../Compliance';
import { MainForm } from '../Main';
import { ButtonWrapper, ConfigWrapper, FormWrapper, Title, Wrapper, } from './ContactListConfigurator.Styles';
import { AccountSelector } from '../../commons/AccountSelector';
import { accounts } from '../../../frontend-config';
import { config_baseURL, set_config_baseURL, baseURL, } from '../../../api/utils';
export var ContactListConfigurator = function (_a) {
    var onDiscardClick = _a.onDiscardClick, creating = _a.creating, contactLists = _a.contactLists, copied = _a.copied, selectedRow = _a.selectedRow, readOnly = _a.readOnly, updateContactListByID = _a.updateContactListByID, addContactList = _a.addContactList, handleOpenSnack = _a.handleOpenSnack, dialerDefaults = _a.dialerDefaults, onAlert = _a.onAlert, onAccountChange = _a.onAccountChange;
    var step = useState(0)[0];
    var _b = useState(true), openStepOne = _b[0], setOpenStepOne = _b[1];
    var _c = useState(true), openStepTwo = _c[0], setOpenStepTwo = _c[1];
    var _d = useState(selectedRow), selectedContactList = _d[0], setSelectedContactList = _d[1];
    var _e = useState(), configAccount = _e[0], setConfigAccount = _e[1];
    var handleDiscard = function (resetForm) {
        resetForm();
        onDiscardClick();
        setSelectedContactList(null);
    };
    var handleSubmit = function (submitForm) {
        submitForm();
    };
    useEffect(function () {
        setSelectedContactList(selectedRow);
        if (selectedRow && selectedRow.prjacc) {
            setConfigAccount(accounts.find(function (a) { return a.url === selectedRow.prjacc.url; }));
            set_config_baseURL(selectedRow.prjacc.url);
            onAccountChange(selectedRow.prjacc.url);
        }
        else if (selectedRow && JSON.stringify(selectedRow) !== '{}') {
            setConfigAccount(accounts.find(function (a) { return a.url === baseURL(); }));
            onAccountChange(baseURL());
            set_config_baseURL(baseURL());
        }
        else {
            setConfigAccount(accounts.find(function (a) { return a.url === config_baseURL(); }));
            onAccountChange(config_baseURL());
        }
    }, [selectedRow]);
    var setFormValues = function (setValues) {
        var contactList = selectedContactList;
        if (contactList && Object.keys(contactList).length > 0) {
            var template = {
                contactListConfigName: contactList.ContactListConfigName,
                contactListTable: contactList.ContactListTable,
                phoneListTable: contactList.PhoneListTable,
                doNotCallTable: contactList.DncTable,
                dncUniqueRecordIdentifier: contactList.DncIdentifier,
                phoneTypes: contactList.PhoneTypes.toString(),
                dailyCallLimitRecord: contactList.Compliance.DailyCallLimitRecord,
                dailyCallLimitPhone: contactList.Compliance.DailyCallLimitPhone
            };
            setValues(template);
        }
    };
    var onSend = function (value, resetForm) {
        var phoneTypeValues = value.phoneTypes.split(',');
        var contactList = {
            ContactListConfigName: value.contactListConfigName,
            ContactListTable: value.contactListTable,
            PhoneListTable: value.phoneListTable,
            DncTable: value.doNotCallTable,
            DncIdentifier: value.dncUniqueRecordIdentifier,
            PhoneTypes: phoneTypeValues,
            Compliance: {
                DailyCallLimitRecord: value.dailyCallLimitRecord,
                DailyCallLimitPhone: value.dailyCallLimitPhone
            }
        };
        if (!creating && !copied) {
            updateContactListByID(contactList, selectedRow.id, selectedContactList);
        }
        else {
            addContactList(contactList);
        }
        handleDiscard(resetForm);
    };
    var checkContactName = function (formValues) {
        var lowerCheck = formValues.contactListConfigName.toLowerCase();
        var contactCheck = contactLists.filter(function (contact) {
            return contact.ContactListConfigName.toLowerCase() === lowerCheck;
        });
        return (contactCheck.length === 0 ||
            (contactCheck.length > 0 &&
                !creating &&
                formValues.contactListConfigName === (selectedContactList === null || selectedContactList === void 0 ? void 0 : selectedContactList.ContactListConfigName)));
    };
    return (React.createElement(Wrapper, null,
        React.createElement(FormWrapper, null,
            React.createElement(Formik, { initialValues: contactListInitialValues, validationSchema: contactListValidationSchema(dialerDefaults), onSubmit: function (values, _a) {
                    var setSubmitting = _a.setSubmitting, resetForm = _a.resetForm;
                    if (checkContactName(values)) {
                        onSend(values, resetForm);
                    }
                    else {
                        onAlert('This Contact List Name is already in use please use a new one', 'warning');
                    }
                    setSubmitting(false);
                } }, function (_a) {
                var submitForm = _a.submitForm, isSubmitting = _a.isSubmitting, resetForm = _a.resetForm, setValues = _a.setValues, setFieldTouched = _a.setFieldTouched, setFieldValue = _a.setFieldValue, handleChange = _a.handleChange, values = _a.values;
                return (React.createElement(Form, null,
                    useEffect(function () {
                        setTimeout(function () {
                            setFormValues(setValues);
                        }, 400);
                    }, [selectedContactList]),
                    React.createElement(Title, { variant: 'h5', gutterBottom: true },
                        React.createElement(Field, { name: 'contactListConfigName', label: 'Contact List', component: EditableTextField }),
                        React.createElement(SubName, { variant: 'body2' }, selectedContactList && selectedContactList.id)),
                    React.createElement(Divider, null),
                    React.createElement(ConfigWrapper, null,
                        React.createElement(AccountSelector, { initialValue: configAccount, onValueChange: function (account) {
                                if (account && account !== 'All') {
                                    setConfigAccount(account);
                                    onAccountChange(account.url);
                                    set_config_baseURL(account.url);
                                }
                            }, fullWidth: true, noAll: true })),
                    React.createElement(Divider, null),
                    React.createElement(Stepper, { activeStep: step, orientation: 'vertical' },
                        React.createElement(Step, { active: openStepOne },
                            React.createElement(StepLabel, { onClick: function () {
                                    setOpenStepOne(!openStepOne);
                                } }, "General"),
                            React.createElement(StepContent, null,
                                React.createElement(MainForm, { formValues: values, creating: creating }))),
                        React.createElement(Step, { active: openStepTwo },
                            React.createElement(StepLabel, { onClick: function () {
                                    setOpenStepTwo(!openStepTwo);
                                } }, "Compliance"),
                            React.createElement(StepContent, null,
                                React.createElement(ComplianceForm, null))),
                        React.createElement(Step, { expanded: true },
                            React.createElement(StepContent, null,
                                React.createElement(ButtonWrapper, null,
                                    React.createElement(Button, { variant: 'contained', color: 'primary', disabled: isSubmitting || readOnly, onClick: function () { return handleSubmit(submitForm); } }, creating === true ? 'Create' : 'Update'),
                                    React.createElement(Button, { variant: 'contained', color: 'primary', onClick: function () { return handleDiscard(resetForm); } }, readOnly ? 'Close' : 'Discard')))))));
            }))));
};
ContactListConfigurator.defaultProps = {
    title: 'Contact List Name'
};
//# sourceMappingURL=ContactListConfigurator.js.map